'use strict';

import Backbone from 'backbone';
import $ from 'jquery';
import {parallelArrayEach} from '../../utilities/uiLoopHelpers';

var ScrollableCarouselView = Backbone.View.extend({
  events: {
    'focus .filterItem': 'onFocusInFilter'
  },

  initialize() {
    this.$items = this.$el.find('li');
    this.controlSelector = '.ScrollableCarousel-controls';
    this.$controls = $(this.controlSelector);
    this.$leftScroll = this.$controls.eq(0);
    this.$rightScroll = this.$controls.eq(1);

    document.getElementById('leftScrollable').disabled  = true;
    document.getElementById('leftScrollable').style.borderRight = '20px solid lightgrey';
    document.getElementById('rightScrollable').disabled = false;
    document.getElementById('rightScrollable').style.borderRight = '20px solid #757575';
    if (this.$el[0].scrollWidth < $(window).width()) {
      this.$rightScroll.hide();
      this.$leftScroll.hide();
      this.$el.addClass('ScrollableCarousel-noControls');
      return;
    } else {
      this.$el.removeClass('ScrollableCarousel-noControls');
    }

    var initialData = {};

    if (window.bootstrappedSearchResponse && window.bootstrappedSearchResponse.data) {
      initialData = window.bootstrappedSearchResponse.data;

      if (initialData.resultsMetadata.unfilteredSearchExecuted === true) {
        this.$controls.addClass('ScrollableCarousel-controls--no-result');
      }
    }

    this.setupDelegates();

  },

  setupDelegates() {
    this.$filterCategoryList = $('.FilterCategoryNavigation');
    this.$filterCategoryList.delegate(this.controlSelector, 'mouseenter', this.scroll.bind(this))
      .delegate(this.controlSelector, 'mouseleave', this.stopScroll.bind(this))
      .delegate(this.controlSelector, 'keypress', this.scroll.bind(this))
      .delegate(this.controlSelector, 'keyup', this.stopScroll.bind(this));
  },

  onFocusInFilter: function(e) {
    e.target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  },

  scroll(event) {

    let totalScrollLength = this.$el[0].clientWidth;
    document.getElementById('scrollContainer').addEventListener('scroll', function() {
      const element = document.getElementById('scrollContainer');
      let horizontalScroll = element.scrollLeft;
      let scrollRight = element.scrollWidth - element.scrollLeft;
      if (scrollRight === totalScrollLength) {
        document.getElementById('rightScrollable').disabled = true;
        document.getElementById('rightScrollable').style.borderRight = '20px solid lightgrey';
        document.getElementById('leftScrollable').disabled = false;
        document.getElementById('leftScrollable').style.borderRight = '20px solid #757575';
      }
      if (horizontalScroll > 0 && scrollRight !== totalScrollLength) {
        document.getElementById('leftScrollable').disabled = false;
        document.getElementById('leftScrollable').style.borderRight = '20px solid #757575';
        document.getElementById('rightScrollable').disabled = false;
        document.getElementById('rightScrollable').style.borderRight = '20px solid #757575';
      }
      if (horizontalScroll === 0) {
        document.getElementById('leftScrollable').disabled = true;
        document.getElementById('leftScrollable').style.borderRight = '20px solid lightgrey';
        document.getElementById('rightScrollable').disabled = false;
        document.getElementById('rightScrollable').style.borderRight = '20px solid #757575';
      }
    });
    let direction = $(event.target).attr('direction');

    let totalWidth = -this.$el.width() + 100;

    // For each, keep scope of item
    this.$items.each(function() {
      totalWidth += $(this).outerWidth(true);
    });

    this.$el.animate({
      scrollLeft: direction + totalWidth
    }, {
      duration: this.$items.length * 500,
      easing: 'linear',
      queue: false
    });
  },

  stopScroll() {
    this.$el.stop();
  }
});

export function create($parent) {
  let elements = $parent.find('.ScrollableCarousel');
  parallelArrayEach(elements, (el) => new ScrollableCarouselView({el}));
}



// WEBPACK FOOTER //
// ./assets/components/ScrollableCarousel/ScrollableCarouselView.js